import { connect } from 'react-redux';

import { IAppState } from 'src/store';
import { Modal, OkModal, RenameModal, YesNoModal } from 'src/components/Modal';
import { modalActions } from 'src/redux/modalRedux';
import { MODAL_TYPES } from 'src/appConfig/modal';
import RejectModal from 'src/components/Modal/RejectModal';

const ModalContainer: React.FC<Props> = ({ startClosing, isVisible, modalType, hideModal }) => {
  if (!isVisible) return null;

  return (
    <Modal onModalClosed={hideModal} triggerCloseModal={startClosing}>
      <ModalBody modalType={modalType} />
    </Modal>
  );
};

const ModalBody = ({ modalType }: { modalType: string }) => {
  switch (modalType) {
    case MODAL_TYPES.OK_MODAL:
      return <OkModal />;
    case MODAL_TYPES.YES_NO_MODAL:
      return <YesNoModal />;
    case MODAL_TYPES.RENAME_MODAL:
      return <RenameModal />;
    case MODAL_TYPES.REJECT_MODAL:
      return <RejectModal />;
    default:
      return <OkModal />;
  }
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & {};

const mapStateToProps = (state: IAppState) => ({
  isVisible: state.modal.isVisible,
  modalType: state.modal.type,
  startClosing: state.modal.startClosing,
});

const mapDispatchToProps = {
  hideModal: modalActions.hideModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);
